
import { WDFormBasic } from './wd-form-basic';
import WDFilter from '../filter/wd-filter';

export class WDFormFilter extends WDFormBasic
{

	#filter = null;

	constructor(cfg)
	{
		cfg.type = 'filter';

		//make sure we have a config parameters
		if (typeof (cfg.config) == 'undefined') 
		{
			throw new Error('No config passed for WDFormFilter');
		}

		const filter = new WDFilter(cfg.config);
		super(filter, cfg);

		//store a reference
		this.#filter = filter;

		this.#filter.on('filters:updated', (evt) =>
		{
			this.trigger('change');
			this.trigger('input');
			this.trigger('value:set');
		});			//need to revisit this

		//populate the form
		if (cfg.value) this.#filter.value = cfg.value;
	};

	get value() { return this.#filter.value; };
	set value(data)
	{
		this.#filter.reset();
		this.#filter.value = data;
	};

};

customElements.define('wd-form-filter', WDFormFilter);

